import { ShieldCheck } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { StoreButtons } from "./StoreButtons";

export const FinalCta = () => (
    <section className="mx-auto max-w-6xl px-6 py-28 sm:py-36" data-testid="final-cta-section">
        <Reveal className="mx-auto max-w-3xl text-center">
            <div className="flex justify-center">
                <Chapter index="07" label="Get Lunar" />
            </div>
            <h2
                data-testid="final-cta-heading"
                className="font-display mt-6 text-[2.6rem] font-medium leading-[1.08] tracking-tight text-[#1D201A] sm:text-6xl"
            >
                Who are you <em className="italic text-[#4A5D23]">missing</em> around you?
            </h2>
            <p className="mt-6 text-lg text-[#3E413B] sm:text-xl">
                Download Lunar and find out.
            </p>
            <div className="mt-10">
                <StoreButtons
                    centered
                    appStoreTestId="final-cta-app-store"
                    googlePlayTestId="final-cta-google-play"
                />
            </div>
            <div
                data-testid="first-meeting-safety-note"
                className="mx-auto mt-10 flex max-w-md items-center justify-center gap-3 rounded-full border border-[#D8D5CB] px-5 py-3 text-sm text-[#5C5F58]"
            >
                <ShieldCheck className="h-4 w-4 shrink-0 text-[#4A5D23]" strokeWidth={1.75} />
                <span>
                    Meeting someone for the first time? We recommend meeting in a public or
                    communal area.
                </span>
            </div>
        </Reveal>
    </section>
);
